
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isBooksOpen, setIsBooksOpen] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [comingSoonPosition, setComingSoonPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleComingSoonClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const rect = (e.target as HTMLElement).getBoundingClientRect();
    setComingSoonPosition({ x: rect.left, y: rect.bottom + 10 });
    setShowComingSoon(true);
    setTimeout(() => setShowComingSoon(false), 2000);
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-[#0A1628]/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Left Navigation */}
            <div className="flex items-center gap-8">
              <div className="relative">
                <button
                  onClick={() => setIsBooksOpen(!isBooksOpen)}
                  className="text-sm font-medium transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap text-white hover:text-[#D4AF37]"
                >
                  도서
                  <i className={`ri-arrow-down-s-line text-base transition-transform ${isBooksOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isBooksOpen && (
                  <div className="absolute top-full left-0 mt-2 bg-[#0F2744] rounded-lg shadow-lg py-2 min-w-[140px] border border-[#D4AF37]/20">
                    <Link to="#" onClick={handleComingSoonClick} className="block px-4 py-2 text-sm text-gray-200 hover:bg-[#D4AF37]/10 hover:text-[#D4AF37] cursor-pointer">
                      전체 도서
                    </Link>
                    <Link to="#" onClick={handleComingSoonClick} className="block px-4 py-2 text-sm text-gray-200 hover:bg-[#D4AF37]/10 hover:text-[#D4AF37] cursor-pointer">
                      신간 도서
                    </Link>
                    <Link to="#" onClick={handleComingSoonClick} className="block px-4 py-2 text-sm text-gray-200 hover:bg-[#D4AF37]/10 hover:text-[#D4AF37] cursor-pointer">
                      베스트셀러
                    </Link>
                  </div>
                )}
              </div>
              <Link to="#" onClick={handleComingSoonClick} className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-white hover:text-[#D4AF37]">
                저자
              </Link>
              <Link to="#" onClick={handleComingSoonClick} className="text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-white hover:text-[#D4AF37]">
                소식
              </Link>
            </div>

            {/* Center Logo */}
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <div className="w-2 h-2 rounded-full bg-[#D4AF37]"></div>
              <span className="text-2xl font-serif font-bold text-white">Cr.edit</span>
            </Link>

            {/* Right Actions */}
            <div className="flex items-center gap-6">
              <button className="w-5 h-5 flex items-center justify-center cursor-pointer">
                <i className="ri-search-line text-lg transition-colors text-white hover:text-[#D4AF37]"></i>
              </button>
              <button className="w-5 h-5 flex items-center justify-center cursor-pointer">
                <i className="ri-global-line text-lg transition-colors text-white hover:text-[#D4AF37]"></i>
              </button>
              <a
                href="mailto:dahae@creditworks.co.kr"
                className="bg-[#D4AF37] text-[#0A1628] px-5 py-2 rounded-full text-sm font-bold hover:bg-[#F4D03F] transition-colors flex items-center gap-2 cursor-pointer whitespace-nowrap"
              >
                문의하기
                <i className="ri-arrow-right-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Coming Soon Popup */}
      {showComingSoon && (
        <div
          className="fixed z-[60] bg-[#D4AF37] text-[#0A1628] px-6 py-3 rounded-lg shadow-xl font-bold text-sm animate-[fadeIn_0.3s_ease-in-out]"
          style={{ left: `${comingSoonPosition.x}px`, top: `${comingSoonPosition.y}px` }}
        >
          Coming Soon...
        </div>
      )}
    </>
  );
}
